module.exports = __webpack_public_path__ + "img/horizontal_4_7_2.d35c2cba.png";